export default function getFullPatientName(firstName, lastName) {
    if (firstName && lastName) {
        return `${firstName} ${lastName}`;
    }
    if (!firstName && !lastName) {
        return '';
    }
    return firstName || lastName;
}
